import { useLocation, useNavigate } from "react-router-dom";
import { navItems } from "../../../../utils/url";
import { theme } from "../../../../helpers/theme";
import ListItem from "@mui/material/ListItem";
import {
    Container,
    StyledList,
    StyledListItemButton,
    StyledListItemTex,
} from "./styles";

export const DesktopMenu = () => {
    let navigate = useNavigate();
    let location = useLocation();

    return (
        <>
            <Container>
                <StyledList >
                    {navItems.map((item) => (
                        <ListItem key={item.key}
                            disablePadding>
                            <StyledListItemButton
                                disableRipple
                                sx={{ textAlign: "center" }}
                                onClick={() => {
                                    navigate(item.url);
                                }}
                            >
                                <StyledListItemTex
                                    primary={item.name}
                                    sx={{
                                        color: item.url === location.pathname ? `${theme.colors.black_primaryText}` : `${theme.colors.gray01_secondaryText}`,
                                    }}
                                />
                            </StyledListItemButton>
                        </ListItem>
                    ))}
                </StyledList>
            </Container>
        </>
    );
};
